/* eslint-disable max-len */
export const GET_AVAILABLE_FORM_BUILDER_SETTINGS = 'FORM_BUILDER_SETTINGS/GET_AVAILABLE_FORM_BUILDER_SETTINGS'
export const GET_AVAILABLE_FORM_BUILDER_SETTINGS_FAILED = 'FORM_BUILDER_SETTINGS/GET_AVAILABLE_FORM_BUILDER_SETTINGS_FAILED'
export const GET_AVAILABLE_FORM_BUILDER_SETTINGS_SUCCESS = 'FORM_BUILDER_SETTINGS/GET_AVAILABLE_FORM_BUILDER_SETTINGS_SUCCESS'

export const CLEAR_AVAILABLE_FORM_BUILDER_SETTINGS = 'FORM_BUILDER_SETTINGS/CLEAR_AVAILABLE_FORM_BUILDER_SETTINGS'
